window.productCategoriesHandler = () => {
  const galleryEvents = () => {
    const boxes = document.querySelectorAll('.jsTabAboutGalleryBox');

    boxes && boxes.forEach((box, boxIndex) => {
      const galleryContainer = box.querySelector('.jsTabAboutGalleryContainer');
      const mainImage = galleryContainer.querySelector('.jsTabAboutGalleryMainImage');
      const galleryNav = galleryContainer.querySelector('.jsTabAboutGalleryNav');
      const galleryNavImageContainers = galleryNav?.querySelectorAll('.TabAboutGalleryNavImageContainer');

      $(mainImage).slick({
        arrows: true,
        asNavFor: galleryNavImageContainers?.length > 4 ? galleryNav : null,
        cssEase: 'linear',
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: true,
      });

      galleryNav && $(galleryNav).slick({
        arrows: false,
        asNavFor: mainImage,
        centerMode: false,
        dots: false,
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
      });
    });
  };

  galleryEvents();
};
